import api from 'api'
import { CACHE_TAG_ACCOUNT_DETAILS, CACHE_TAG_ACCOUNT_DETAILS_BY_ID, CACHE_TAG_ACCOUNT_LIST } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    // Its own route: the account PUT rewrites the whole account and would clear what it is not sent.
    updateTaxExempt: build.mutation<void, { accountId: string; taxExempt: boolean }>({
      invalidatesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_DETAILS,
        CACHE_TAG_ACCOUNT_LIST,
        { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
      ],
      query: ({ accountId, taxExempt }) => ({
        url: `/api/v1/core/accounts/${accountId}/tax-exempt`,
        method: 'PATCH',
        body: { taxExempt },
      }),
    }),
  }),
})

export const { useUpdateTaxExemptMutation } = extendedApi
